<template>
  <v-card>
    <v-card-title primary-title>
      {{ $t('auth.CreateOrg.title') }}
    </v-card-title>
    <v-card-text>
      <v-form
        lazy-validation
        @submit.prevent="submit"
        ref="form"
      >
        <v-text-field
          filled
          required
          :rules="validation.required"
          data-cy="CreateOrg-name"
          :label="$t('auth.CreateOrg.name')"
          v-model="localOrganization.name"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="success" type="submit" class="ml-4" :loading="isSaving"
            data-cy="CreateOrg-button-save"> {{ $t('common.next')}} </v-btn>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import loading from '../mixins/loading';

export default {
  module: 'auth',
  name: 'CreateOrg',
  mixins: [loading],
  data() {
    return {
      /**
      * Local value used for property Organization
      */
      localOrganization: {},
    };
  },
  methods: {
    ...mapActions('organizations', ['CREATE_organization']),
    /** Submit Form data trigger
     * @event organization.saved
     * @type {object}
     */
    async submit() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;
        const organization = await this.CREATE_organization(this.localOrganization);
        this.isSaving = false;
        this.$root.$emit('organization.saved', organization);
      }
    },
  },
};
</script>
